/* eslint-disable indent */
import React, { useRef, useState } from 'react'
import CardsList from './card-list'

const MAX_ITEMS = 8

const sortItems = (items) => {
  return items.sort((a, b) => {
    const ha = a.Heading.toLowerCase().trim()
    const hb = b.Heading.toLowerCase().trim()

    if (ha < hb) {
        return -1
    }
    if (ha > hb) {
        return 1
    }
    return 0
  })
}

function FilteredListing({
  showFilter,
  content,
  filters,
  buttonLabel,
  noResultsMessage,
  heading,
  labelSet
}) {
  const sortedItems = sortItems(JSON.parse(content).Items)
  const [items, setItems] = useState(sortedItems|| null)
  const [filter, setFilter] = useState(showFilter === 'true' ? true : false)
  const [activeItems, setActiveItems] = useState(sortedItems || null)
  const [filtersData] = useState(JSON.parse(filters) || null)
  const [filterValues, setFilterValues] = useState(['', '', ''])

  const [limit, setLimit] = useState(MAX_ITEMS)
  const loadMore = () => setLimit((prev) => prev + MAX_ITEMS)
  const setOption = (value, id) => {
    const tempValues = filterValues

    tempValues[id] = value

    const clearedValues = tempValues.filter((val) => val !== '')

    setLimit(MAX_ITEMS)

    if (clearedValues.length > 0) {
      setActiveItems(items.filter((item) => clearedValues.every((val) => item.Tags?.includes(val))))
    } else {
      setActiveItems(items)
    }

    setFilterValues(tempValues)
  }

  const labels = JSON.parse(labelSet)

  return (
    <div className="filtered-content__wrapper">
      <header className="filter-content__header">
        <h2 className="filter-content__heading">{heading}</h2>
        {filtersData?.length > 0 && filter ? (
          <div className="filter-content__filters">
            {filtersData.map((filterData, index) => (
              <select
                key={index}
                className="filter-content__select select"
                onChange={(e) => setOption(e.target.value, index)}
                defaultValue={filterData.Options?.[0] || null}
              >
                <option value="">{filterData.FilterLabel}</option>
                {filterData.Options.length > 0 &&
                  filterData.Options.map((option, index) =>
                    option.Child.map((childOption, index) => (
                      <>
                        <option value={childOption.Id} key={childOption.Id}>
                          {childOption.Heading}
                        </option>
                        {childOption.Children?.length > 0 ? (
                          <>
                            {childOption.Children?.map((grandChildren, index) => (
                              <option
                                className="filter-content__select-grandchildren"
                                value={grandChildren.Id}
                                key={grandChildren.Id}
                              >
                                &nbsp;&nbsp;&nbsp;{grandChildren.Heading}
                              </option>
                            ))}
                          </>
                        ) : null}
                      </>
                    ))
                  )}
              </select>
            ))}
          </div>
        ) : null}
      </header>
      <div className="filter-content__list-grid">
        {activeItems?.length > 0 ? (
          <CardsList cards={activeItems} limit={limit} />
        ) : (
          <p className="filter-content__no-results-message">{noResultsMessage}</p>
        )}
      </div>
      {activeItems?.length > limit ? (
        <button
          onClick={() => loadMore()}
          className="btn btn--yellow btn--small filter-content__btn"
        >
          {buttonLabel}
        </button>
      ) : null}
    </div>
  )
}

export default FilteredListing
